// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFileWithIdTemplate } from "./RanaFileWithIdTemplate";
import {
  RanaFileWithIdTemplateFromJSON,
  RanaFileWithIdTemplateFromJSONTyped,
  RanaFileWithIdTemplateToJSON,
  RanaFileWithIdTemplateToJSONTyped,
} from "./RanaFileWithIdTemplate";

/**
 *
 * @export
 * @interface DefineStudyAreaOutput
 */
export interface DefineStudyAreaOutput {
  /**
   *
   */
  studyArea: RanaFileWithIdTemplate;
}

/**
 * Check if a given object implements the DefineStudyAreaOutput interface.
 */
export function instanceOfDefineStudyAreaOutput(value: object): value is DefineStudyAreaOutput {
  if (
    (!("studyArea" in (value as Record<string, any>)) &&
      !("study_area" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["studyArea"] === undefined &&
      (value as Record<string, any>)["study_area"] === undefined)
  )
    return false;
  return true;
}

export function DefineStudyAreaOutputFromJSON(json: any): DefineStudyAreaOutput {
  return DefineStudyAreaOutputFromJSONTyped(json, false);
}

export function DefineStudyAreaOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DefineStudyAreaOutput {
  if (json == null) {
    return json;
  }
  return {
    studyArea: RanaFileWithIdTemplateFromJSON(json["study_area"]),
  };
}

export function DefineStudyAreaOutputToJSON(json: any): DefineStudyAreaOutput {
  return DefineStudyAreaOutputToJSONTyped(json, false);
}

export function DefineStudyAreaOutputToJSONTyped(
  value?: DefineStudyAreaOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    study_area: RanaFileWithIdTemplateToJSON(value["studyArea"]),
  };
}
